import React, { Component } from 'react';
import { Link } from 'react-router';

class JobCTAItem extends Component {
    render() {

        const { purchased } = this.props;

        return (
            <div className="cta-bar brand-background-color">
                <span>Get full access to our jobs board for Free with one of our membership packages</span>
                {
                    !purchased ?
                    (
                        <Link to='/purchases' className="btn btn-primary">
                            <span className="label">Upgrade now</span>
                            <span className="icon"><i className="fa fa-arrow-up fa-right"/></span>
                        </Link>
                    ) :
                    <mark className="btn btn-primary disabled">
	                    <span className="icon"><i className="fa fa-check fa-left"/></span>
	                    <span className="label">Added to your basket</span>
                    </mark>
                }

            </div>
        );
    };
}
export default JobCTAItem;



// WEBPACK FOOTER //
// src/client/components/common/transactions/JobCTAItem.js